

















































































































































import { Component, Prop, Vue } from 'vue-property-decorator';

import { Typography } from '@/components/atoms';
import Thumb from '@/components/molecules/Thumb/Thumb.vue';
import ArrowRightInfoIcon from '@/components/icons/ArrowRightInfo.vue';
import WalletIcon from '@/components/icons/Wallet.vue';
import DefaultCoinIcon from '@/components/icons/DefaultCoin.vue';
import InfoIcon from '@/components/icons/Info.vue';

import { pluralize } from '@/utils';

@Component<LoyaltyExample>({
  components: {
    Typography,
    Thumb,
    ArrowRightInfoIcon,
    WalletIcon,
    DefaultCoinIcon,
    InfoIcon
  },
  computed: {
    exampleInfo() {
      const amountSpent = this.amountSpent;
      const percentInCoins = this.percentInCoins || 0;

      const coinsAndDiscount = (percentInCoins * amountSpent) / 100;

      return {
        amountSpent,
        coinsAndDiscount
      };
    }
  }
})
export default class LoyaltyExample extends Vue {
  @Prop({ default: 0 }) percentInCoins?: number;
  @Prop({ default: '/img/onboarding/customer-example.png' })
  customerImage?: string;
  @Prop({ default: '' }) businessImage?: string;
  @Prop({ default: 'center' }) alignTitle?: 'left' | 'center' | 'right';
  @Prop({ default: false }) resetMargins?: boolean;
  @Prop({ default: false }) bonusSetting?: boolean;

  amountSpent = 100;
  pluralize = pluralize;

  get tPrefix() {
    if (this.bonusSetting) {
      return 'common.components.loyaltyExampleV2';
    }

    return 'common.components.loyaltyExample';
  }

  get currencyName() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencyShorthand;
  }

  get currencySymbol() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }
}
